/**
 * Unique symbol used to identify entity collection between modules.
 * 
 * @type {unique symbol}
 */
export const entityCollectionSymbol: unique symbol = Symbol.for('$DSEntityCollection');
